import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import '../styles/navbar.css'
import '../styles/sub-navbar.css';
import {useHeaderComponent} from "../hooks/useHeaderComponent";
import {useUserInfo} from "../hooks/useUserInfo";
import {useLocation, useNavigate} from "react-router-dom";
import {Api} from "../services/api";
import {MenuItem, MenuItemOptions} from "primereact/menuitem";
import {Menubar} from "primereact/menubar";
import styled from "styled-components";
import {Badge} from "primereact/badge";
import {useOfferCounts} from "../hooks/swr/offer/useOfferCounts";
import {mutate} from "swr";

interface Props {

}

const NewSystem = styled.span`
  position: fixed;
  left: 10px;
  top: 25px;
  z-index: 100;
  font-size: 2rem;
  color: white;
`

const ActiveUser = styled.span`
  //position: fixed;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  right: 10px;
  top: 25px;
  z-index: 100;
  font-size: 1rem;
  color: white;
`

const BrokerNavigation : React.FC<Props> = props => {
    const didMountRef = useRef(false);
    const {formatMessage: f} = useIntl();

    const offerSubModules = ['edit', 'tickets', 'deals', 'contracts'];
    const {weekPickerState, component} = useHeaderComponent();
    const {updateUserInfo} = useUserInfo();
    const {userInfo} = useUserInfo();
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const api = new Api();

    const [offerId, setOfferId] = useState<number>();

    const {data: offerCounts, mutationKey: offerCountsMutationKey} = useOfferCounts(offerId);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    useEffect(() => {
        //In offers -> submodule
        if(pathname.includes('/offers') && offerSubModules.some(subModule => pathname.includes(subModule))){
            const offerIdRegex = /\d+/;
            const match = pathname.match(offerIdRegex);
            const offerId = match && match[0];
            if(offerId && !isNaN(+offerId)){
                setOfferId(+offerId);
            }
            mutate(offerCountsMutationKey);
        }
    }, [pathname]);


    const getMainMenuActiveClass = (module: string) => {
        return pathname.includes(module) ? 'active' : '';
    }

    const getMainMenuActiveClasses = (modules: string[]) => {
        return modules.reduce((acc, el) => {
            return acc || pathname.includes(el);
        }, false) ? 'active' : '';
    }

    const getSubMenuActiveClass = (module: string) => {
        return pathname.includes(module) ? 'active' : '';
    }

    const getSubMenuActiveClasses = (modules: string[]) => {
        return modules.reduce((acc, el) => {
            return acc || pathname.includes(el);
        }, false) ? 'active' : '';
    }

    const handleLogout = () => {
        api.api.logout().then(() => {
            navigate("/");
            updateUserInfo({
                authenticated: false,
                userId: undefined,
                role: undefined,
                username: undefined,
                names: undefined
            });
        });
    };

    const loginItems: MenuItem[] = [
        {
            label: f({id: "systemLogin"}),
            className: `nav-item `,
            command: () => navigate('/login')
        },
    ]

    const mainItems: MenuItem[] = [
        {
            label: f({id: "offers"}),
            className: `nav-item ${getMainMenuActiveClass('offers')}`,
            command: () => navigate('/broker-offers/online')
        },
        {
            label: f({id: "session"}),
            className: `nav-item ${getMainMenuActiveClass('session')}`,
            command: () => navigate('/session')
        },
        {
            label: f({id: "administration"}),
            className: `nav-item ${getMainMenuActiveClass('administration')}`,
            command: () => navigate('/administration')
        },
        {label: f({id: "logOut"}), className: `nav-item`, command: () => handleLogout()}
    ]

    const getMenuItems = () => {
        if (!userInfo.authenticated || userInfo.shouldChangePassword) {
            return loginItems;
        }
        return mainItems;
    }

    const offerSubmenuItemTemplate = (module: 'all' | 'withDeal' | 'withTicket' | 'withContract' | 'forApproval', item: MenuItem) => {
        console.log("THE TEMPLATE ");
        const countObject = offerCounts;

        let label;
        if (countObject && countObject[module])
            label = <span>{item.label}<Badge className={'ml-2'} value={countObject[module]}/></span>
        else
            label = <span>{item.label}</span>

        //@ts-ignore
        return <a onClick={item.command} role="menuitem" className="p-menuitem-link nav-link" aria-haspopup="false" data-pc-section="action">
            <span className="p-menuitem-text" data-pc-section="label">{label}</span>
        </a>
    }

    const getSubItems = (): MenuItem[] => {
        if (!userInfo.authenticated || userInfo.shouldChangePassword) {
            return [];
        }
        else if(pathname.includes('offers')){
            if(pathname.includes("readOnly")){
                const offerIdRegex = /\d+/;
                const match = pathname.match(offerIdRegex);
                var offerId = match && match[0];
                if(offerId == null)
                    return [];

                return [
                    {
                        label: f({id: "offer"}),
                        className: `nav-item ${getSubMenuActiveClass(`offers/${offerId}/edit/readOnly`)}`,
                        command: () => navigate(`offers/${offerId}/edit/readOnly`)
                    },
                    {
                        label: f({id: "deals"}),
                        className: `nav-item ${getSubMenuActiveClass(`offers/${offerId}/deals/readOnly`)}`,
                        command: () => navigate(`offers/${offerId}/deals/readOnly`),
                        template: offerSubmenuItemTemplate.bind(undefined, 'withDeal')
                    },
                    {
                        label: f({id: "tickets"}),
                        className: `nav-item ${getSubMenuActiveClass(`offers/${offerId}/tickets/readOnly`)}`,
                        command: () => navigate(`offers/${offerId}/tickets/readOnly`),
                        template: offerSubmenuItemTemplate.bind(undefined, 'withTicket')
                    },
                    {
                        label: f({id: "contracts"}),
                        className: `nav-item ${getSubMenuActiveClass(`offers/${offerId}/contracts/readOnly`)}`,
                        command: () => navigate(`offers/${offerId}/contracts/readOnly`),
                        template: offerSubmenuItemTemplate.bind(undefined, 'withContract')
                    }
                ]
            }else {
                return [
                    {
                        label: f({id: "onlineOffers"}),
                        className: `nav-item ${getSubMenuActiveClass(`broker-offers/online`)}`,
                        command: () => navigate(`broker-offers/online`)
                    },
                    {
                        label: f({id: "myOffers"}),
                        className: `nav-item ${getSubMenuActiveClasses([`broker-offers/all`, 'broker-offers/create', 'broker-offers/edit', 'broker-offers/upload', 'readOnly'])}`,
                        command: () => navigate(`broker-offers/all`)
                    }
                ]
            }
        }

        return [];
    }

    return <>
        {/*<NewSystem>Нова Система</NewSystem>*/}

        <nav className={'navbar bg-primary fixed-top fixed-top-mainmenu'}>
            <div className="container">
                <a className="navbar-brand" onClick={() => navigate('/broker-offers/online')} data-qa="homeLink">
                    <img src="/logo.svg" width="64" height="64" alt="SCE-Logo"/>
                </a>

                {/*{shouldRenderBackToSession ? <Button onClick={handleBackToSession} className={'nav-item-session'}>{f({id: 'backToSession'})}</Button> : null}*/}

                <ActiveUser>
                    <label>{userInfo.username}</label>
                    <label>{userInfo.names}</label>
                </ActiveUser>


                <Menubar model={getMenuItems()} className={'navbar-menu-bar'} pt={{action: {className: 'nav-link'}}}/>
            </div>
        </nav>

        {(userInfo.authenticated && !userInfo.shouldChangePassword) &&
            <nav className={'navbar navbar-expand-md navbar-light bg-white fixed-top fixed-top-submenu'}>
                <div className="container flex justify-content-space-between">
                    {component}
                    {getSubItems().length > 0 &&
                        <Menubar model={getSubItems()} className={'navbar-submenu-bar'}
                                 pt={{action: {className: 'nav-link'}}}/>
                    }
                </div>
            </nav>
        }
    </>
};

export default BrokerNavigation
